module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAwElEQVQokXXSIQvCQBjG8f9OUbCY7H4ANRpMp4ioaNqn2RdwX2aHxWRww2AwDrPFYBAEi3Uy2MZ5u3vThR/P83K83i6K78ATWAe+/GAZATyACXAMVdJ1oRUQA2MXFIEvv8BGg+dQJT0zCQOOgJMORfkw4ECHXpZlf/2hSjqAApbADZjVUAFbQARsgVTUhOMLbHX7IiWvmzct4ABMy30CX76qJBeo6gyQ6iCfRnsodXAtwNtcXAcL2yXkqA9cXADgB0RtT38FaqeNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/second/second_equipment_arrow.png
// module id = FrhU
// module chunks = 1